module.exports = __webpack_public_path__ + "static/media/icone_maison.54b431b3.svg";